module.exports = __webpack_public_path__ + "static/img/smoke1.c59e1b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/particles/images/smoke1.png
// module id = BIZ3
// module chunks = 0